export default class Component {
    constructor(data) {
        Object.assign(this, data)
    }

    getRef() {
        let value = this.name
        if (this.scope && this.scope != '') {
            value = `${this.scope}::${this.name}`
        }

        return value
    }
}